import { cssPrefix } from '../../../../const/Constant';
import { Icon } from './Icon';
import { Item } from './base/Item';

class UnderLine extends Item {
  constructor() {
    super(`${cssPrefix}-tools-under-line`);
    this.icon = new Icon('under-line');
    this.childrenNodes(this.icon);
    this.setTitleTips('下划线');
  }
}

export { UnderLine };
